import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFathomComponent } from './simple-icons-fathom.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFathomComponent ],
    exports:      [ SimpleIconsFathomComponent ],
    bootstrap:    []
})
export class SimpleIconsFathomModule {}
